import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { CampaignSearchState } from '../models/campaign-search.model';
import * as selectors from '../selectors/campaign-search.selector';

@Injectable({
  providedIn: 'root',
})
export class CampaignSearchFacadeService extends FacadeService {
  constructor(public override store: Store<CampaignSearchState>) {
    super(store);
  }

  // OBSERVABLES
  categories$ = this.storeSelect(selectors.getCategories);

  schemas$ = this.storeSelect(selectors.getSchemas);

  statusTypes$ = this.storeSelect(selectors.getStatusTypes);

  targetGroups$ = this.storeSelect(selectors.getTargetGroups);

  channels$ = this.storeSelect(selectors.getChannels);

  targetsGroups$ = this.storeSelect(selectors.getTargetGroups);

  countries$ = this.storeSelect(selectors.getCountries);

  searchPanelExpanded$ = this.storeSelect(selectors.getSearchPanelExpanded);

  basicFiltersPanelExpanded$ = this.storeSelect(selectors.getBasicFiltersPanelExpanded);

  advancedFiltersPanelExpanded$ = this.storeSelect(selectors.getAdvancedPanelExpanded);

  name$ = this.storeSelect(selectors.getName);

  category$ = this.storeSelect(selectors.getCategory);

  notes$ = this.storeSelect(selectors.getNotes);

  description$ = this.storeSelect(selectors.getDescription);

  status$ = this.storeSelect(selectors.getStatus);

  targetGroup$ = this.storeSelect(selectors.getTargetGroup);

  schema$ = this.storeSelect(selectors.getSchema);

  channel$ = this.storeSelect(selectors.getChannel);

  activeCampaigns$ = this.storeSelect(selectors.getActiveCampaigns);

  deletedCampaigns$ = this.storeSelect(selectors.getDeletedCampaigns);

  myCampaigns$ = this.storeSelect(selectors.getMyCampaigns);

  activeFromStartDate$ = this.storeSelect(selectors.getActiveFromStartDate);

  showActiveFromStartDateShowClearBtn$ = this.storeSelect(selectors.showActiveFromStartDateShowClearBtn);

  showActiveFromEndDateShowClearBtn$ = this.storeSelect(selectors.showActiveFromEndDateShowClearBtn);

  showActiveUntilStartDateShowClearBtn$ = this.storeSelect(selectors.showActiveUntilStartDateShowClearBtn);

  showActiveUntilEndDateShowClearBtn$ = this.storeSelect(selectors.showActiveUntilEndDateShowClearBtn);

  activeFromEndDate$ = this.storeSelect(selectors.getActiveFromEndDate);

  activeUntilStartDate$ = this.storeSelect(selectors.getActiveUntilStartDate);

  activeUntilEndDate$ = this.storeSelect(selectors.getActiveUntilEndDate);

  dateTypeFrom$ = this.storeSelect(selectors.getDateTypeFrom);

  useTimeFrom$ = this.storeSelect(selectors.getUseTimeFrom);

  dateTypeUntil$ = this.storeSelect(selectors.getDateTypeUntil);

  useTimeUntil$ = this.storeSelect(selectors.getUseTimeUntil);

  showSingleDateRegularFrom$ = this.storeSelect(selectors.getShowSingleDateRegularFrom);

  showRangeDateRegularFrom$ = this.storeSelect(selectors.getShowRangeDateRegularFrom);

  showSingleDateTimedFrom$ = this.storeSelect(selectors.getShowSingleDateTimedFrom);

  showRangeDateTimedFrom$ = this.storeSelect(selectors.getShowRangeDateTimedFrom);

  showSingleDateRegularUntil$ = this.storeSelect(selectors.getShowSingleDateRegularUntil);

  showRangeDateRegularUntil$ = this.storeSelect(selectors.getShowRangeDateRegularUntil);

  showSingleDateTimedUntil$ = this.storeSelect(selectors.getShowSingleDateTimedUntil);

  showRangeDateTimedUntil$ = this.storeSelect(selectors.getShowRangeDateTimedUntil);

  selectedCampaign$ = this.storeSelect(selectors.getSelectedCampaign);

  verificationInput$ = this.storeSelect(selectors.getVerificationInput);

  verificationMismatch$ = this.storeSelect(selectors.getVerificationMismatch);

  campaignNotes$ = this.storeSelect(selectors.getCampaignNotes);

  duplicateCampaignName$ = this.storeSelect(selectors.getDuplicateCampaignName);

  originalCampaignDeactivation$ = this.storeSelect(selectors.getOriginalCampaignDeactivation);

  duplicateCampaignNameMaxLengthExceeded$ = this.storeSelect(selectors.getDuplicateCampaignNameMaxLengthExceeded);

  showDuplicateNameErrorMessage$ = this.storeSelect(selectors.getShowDuplicateNameErrorMessage);

  disabledDuplicationButton$ = this.storeSelect(selectors.getDisabledDuplicationButton);

  campaignDeactivation$ = this.storeSelect(selectors.getCampaignDeactivation);

  // OBSERVABLE'S VALUES

  get searchPanelExpanded() {
    return this.storeSnapshot(this.searchPanelExpanded$);
  }

  get basicFiltersPanelExpanded() {
    return this.storeSnapshot(this.basicFiltersPanelExpanded$);
  }
  
  get advancedFiltersPanelExpanded() {
    return this.storeSnapshot(this.advancedFiltersPanelExpanded$);
  }

  get dateTypeFrom() {
    return this.storeSnapshot(this.dateTypeFrom$);
  }

  get useTimeFrom() {
    return this.storeSnapshot(this.useTimeFrom$);
  }

  get dateTypeUntil() {
    return this.storeSnapshot(this.dateTypeUntil$);
  }
  get useTimeUntil() {
    return this.storeSnapshot(this.useTimeUntil$);
  }

  get activeFromStartDate() {
    return this.storeSnapshot(this.activeFromStartDate$);
  }

  get activeFromEndDate() {
    return this.storeSnapshot(this.activeFromEndDate$);
  }

  get activeUntilStartDate() {
    return this.storeSnapshot(this.activeUntilStartDate$);
  }

  get activeUntilEndDate() {
    return this.storeSnapshot(this.activeUntilEndDate$);
  }

  get category() {
    return this.storeSnapshot(this.category$);
  }

  get channel() {
    return this.storeSnapshot(this.channel$);
  }

  get name() {
    return this.storeSnapshot(this.name$);
  }

  get targetGroup() {
    return this.storeSnapshot(this.targetGroup$);
  }

  get status() {
    return this.storeSnapshot(this.status$);
  }

  get activeCampaigns() {
    return this.storeSnapshot(this.activeCampaigns$);
  }

  get deletedCampaigns() {
    return this.storeSnapshot(this.deletedCampaigns$);
  }

  get myCampaigns() {
    return this.storeSnapshot(this.myCampaigns$);
  }

  get description() {
    return this.storeSnapshot(this.description$);
  }

  get schema() {
    return this.storeSnapshot(this.schema$);
  }

  get schemas() {
    return this.storeSnapshot(this.schemas$);
  }

  get notes() {
    return this.storeSnapshot(this.notes$);
  }

  get countries() {
    return this.storeSnapshot(this.countries$);
  }

  get categories() {
    return this.storeSnapshot(this.categories$);
  }

  get selectedCampaign() {
    return this.storeSnapshot(this.selectedCampaign$);
  }

  get verificationInput() {
    return this.storeSnapshot(this.verificationInput$);
  }

  get verificationMismatch() {
    return this.storeSnapshot(this.verificationMismatch$);
  }

  get campaignNotes() {
    return this.storeSnapshot(this.campaignNotes$);
  }

  get duplicateCampaignName() {
    return this.storeSnapshot(this.duplicateCampaignName$);
  }

  get originalCampaignDeactivation() {
    return this.storeSnapshot(this.originalCampaignDeactivation$);
  }

  get duplicateCampaignNameMaxLengthExceeded() {
    return this.storeSnapshot(this.duplicateCampaignNameMaxLengthExceeded$);
  }

  get campaignDeactivation() {
    return this.storeSnapshot(this.campaignDeactivation$);
  }
}
